import React, { useState } from "react";
import { FaImage } from "react-icons/fa";
import { Portfolio, PortfolioProject } from "../../../../../graphql/generated";
import ImageLoader from "../../../../common/ImageLoader";
import ProjectDetailsModal from "./comps/ProjectDetailsModal";
import { ProjectCard, ProjectList, ProjectsSectionWrapper } from "./styled";

interface Props {
  portfolioData: Omit<Portfolio, "createdBy">;
}

const ProjectsSection: React.FC<Props> = ({ portfolioData }) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [currentProject, setCurrentProject] = useState<PortfolioProject | null>(
    null
  );

  const allProjects = portfolioData?.projects || [];

  const onPrevClick = () => {
    if (currentProject && showModal) {
      const currentProjectIndex = allProjects.findIndex(
        (p) => p.id === currentProject.id
      );
      const isPreviousProjectExist = !!allProjects[currentProjectIndex - 1];
      if (isPreviousProjectExist) {
        setCurrentProject(
          allProjects[
            allProjects.findIndex((p) => p.id === currentProject.id) - 1
          ]
        );
      } else {
        const tempProjects = [...allProjects];
        setCurrentProject(tempProjects.reverse()[0]);
      }
    }
  };

  const onNextClick = () => {
    if (currentProject && showModal) {
      const currentProjectIndex = allProjects.findIndex(
        (p) => p.id === currentProject.id
      );
      const isNextProjectExist = !!allProjects[currentProjectIndex + 1];
      if (isNextProjectExist) {
        setCurrentProject(
          allProjects[
            allProjects.findIndex((p) => p.id === currentProject.id) + 1
          ]
        );
      } else {
        const tempProjects = [...allProjects];
        setCurrentProject(tempProjects[0]);
      }
    }
  };

  return (
    <ProjectsSectionWrapper>
      <ProjectList>
        {allProjects.map((item) => (
          <ProjectCard key={item.id}>
            <ImageLoader src={item.images.thumbnailImg} alt={item.name} />

            <div>
              <FaImage
                onClick={() => {
                  setCurrentProject(item);
                  setShowModal(true);
                }}
              />
            </div>
          </ProjectCard>
        ))}
      </ProjectList>

      <ProjectDetailsModal
        showModal={showModal}
        closeModal={() => setShowModal(false)}
        currentProject={currentProject}
        onPrevClick={onPrevClick}
        onNextClick={onNextClick}
      />
    </ProjectsSectionWrapper>
  );
};

export default ProjectsSection;
